import { createIndicator } from "@nexus/widget-kit";

const indicator = createIndicator({
  id: "cdnsa-indicator",
  name: "CDN Security Analytics",
  description: "Up to three distinct observed CDN/SA measurements.",
  source: "cdnsa-metrics",
  sources: ["cdnsa-metrics"],
  comparison: true,
  figures: 3,
  periodDetail: false,
});

export const { manifest, Component, defaultConfig, settings } = indicator;
export default indicator;
